<template>
  <div>
    <div class="card task-toolbar" v-if="getTaskToolbarState">
      <div class="card-body pt-2">
        <div style="min-height:40px;">
          <font-awesome-icon icon="times" class="float-right cursor-pointer color-white" @click="closeToolbar()"/>
          <div class="row" v-if="getActiveTaskObject">
            <div class="">
              <p class="mb-1 text-dark" v-if="getActiveTaskObject.project">
                <font-awesome-icon icon="calendar-alt" class="mr-1" size="lg"/>
                {{ getActiveTaskObject.project.title }}
              </p>
              <p class="mt-1 mb-0" v-if="getActiveTaskObject.model">
                <font-awesome-icon icon="desktop" size="lg" class="mr-1" v-if="getActiveTaskObject.model.who_am_i == 'App\\System\\Models\\System'"/>
                <font-awesome-icon icon="cubes" size="lg" class="mr-1" v-if="getActiveTaskObject.model.who_am_i == 'App\\Activity\\Models\\Activity'"/>
                <font-awesome-icon icon="cube" size="lg" class="mr-1" v-if="getActiveTaskObject.model.who_am_i == 'App\\Process\\Models\\Process'"/>
                <font-awesome-icon icon="exchange-alt" size="lg" class="mr-1" v-if="getActiveTaskObject.model.who_am_i == 'App\\Maintenance\\ThirdParty\\Models\\ThirdParty'"/>
                {{ getActiveTaskObject.model.name }} >
                <span v-if="getActiveTaskObject.project.type == 'update' || getActiveTaskObject.project.type == 'validation'">
                  {{ $t('tasks.values.' + $options.filters.slugify(getActiveTaskObject.title)) }}
                </span>
                <span v-if="getActiveTaskObject.project.type == 'control' || getActiveTaskObject.project.type == 'security_measure' || getActiveTaskObject.project.type == 'risk_assessment' || getActiveTaskObject.project.type == 'control_assessment'">
                  {{ getActiveTaskObject.title }}
                </span>
              </p>
            </div>

          </div>
        </div>

        <div class="row mt-2">
          <div class="col-sm-4">
            <span v-if="getActiveTaskObject.project">
              <vm-progress
                  type="circle"
                  :percentage="(getActiveTaskObject.project.user_progress.progress)"
                  style="vertical-align: middle;"
                  :width="42"
                  :stroke-width="2"
                  stroke-color="#00c29e"
                  class="float-left mr-3"
              >
                {{getActiveTaskObject.project.user_progress.progress}}%
              </vm-progress>
            </span>
          </div>
          <div class="col-sm-8">
            <div class="mt-2 text-right">
              <UpdateTaskModal
                  :task="getActiveTaskObject"
                  :tasks="getActiveTaskObject.project"
                  v-if="getActiveTaskObject.project.type == 'update'"
                  @showViewModal="openViewProjectModal(getActiveTaskObject.project)"
                  class="mt-2"
              ></UpdateTaskModal>
              <ValidationTaskModal
                  :task="getActiveTaskObject"
                  :tasks="getActiveTaskObject.project"
                  v-if="getActiveTaskObject.project.type == 'validation'"
                  @showViewModal="openViewProjectModal(getActiveTaskObject.project)"
                  class="mt-2"
              ></ValidationTaskModal>
              <RiskTaskModal
                  :task="getActiveTaskObject"
                  :tasks="getActiveTaskObject.project"
                  v-if="getActiveTaskObject.project.type == 'control' || getActiveTaskObject.project.type == 'security_measure'"
                  @showViewModal="openViewProjectModal(getActiveTaskObject.project)"
                  class="mt-2"
              ></RiskTaskModal>
              <AssessmentTaskModal
                  :task="getActiveTaskObject"
                  :tasks="getActiveTaskObject.project"
                  v-if="getActiveTaskObject.project.type == 'risk_assessment' || getActiveTaskObject.project.type == 'bia_assessment'"
                  @showViewModal="openViewProjectModal(getActiveTaskObject.project)"
                  class="mt-2"
              ></AssessmentTaskModal>
              <AssessmentGlobalSingleTaskModal
                  :task="getActiveTaskObject"
                  :tasks="getActiveTaskObject.project"
                  v-if="getActiveTaskObject.project.type == 'control_assessment'"
                  @showViewModal="openViewProjectModal(getActiveTaskObject.project)"
                  class="mt-2"
                  :fromHomepage="true"
              ></AssessmentGlobalSingleTaskModal>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
       ref="view-project"
       hide-footer
       @hide="hideViewProjectModal"
       size="xl"
    >

      <template #modal-header="{ close }">
        <div class="text-center" style="width: 100%;">
          <span @click="hideViewProjectModal" class="btn btn-secondary cursor-pointer float-right">
            <font-awesome-icon icon="times"/>
          </span>
          <h5 class="mb-2" v-if="selectedProject">
            {{ $t('projects.tasks_modal.title') }}
            <router-link
                :to="{ name: 'projects.view', params: { slug: selectedProject.slug }}"
                qid="s-view-page-link"
                class="breadcrumb-item ml-2"
                v-if="isOwner(selectedProject)"
            >
              <font-awesome-icon icon="calendar-alt" class="mr-1 breadcrumb-item"/>
              {{ selectedProject.title }}
            </router-link>
            <span v-if="!isOwner(selectedProject)" class="ml-2 text-success breaducrumb-item" style="pointer-events:none;">
              <font-awesome-icon icon="calendar-alt" class="mr-1"/>
              {{ selectedProject.title }}
            </span>
          </h5>
        </div>
      </template>

      <table class="table table-responsive-md table-list-secondary">
        <thead>
          <tr>
            <th>
              {{ $t('projects.table.name') }}
            </th>
            <th>
              {{ $t('table.asset') }}
            </th>
            <th>
              {{ $t('tasks.table.assignee') }}
            </th>
            <th>
              {{ $t('system.status') }}
            </th>
            <th width="320"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="object in open_tasks" v-if="open_tasks && open_tasks.length">
            <td>
              <span v-if="object.code == 'business_risk_assessment' || object.code == 'privacy_risk_assessment' || object.code == 'system_impact_assessment'">
                {{ $t('maintenance.assessments.system_impact_assessment_label') }}
              </span>
              <span v-else>
                <span v-if="selectedProject.type && (selectedProject.type == 'update' || selectedProject.type == 'validation')">
                  {{ $t('tasks.values.' + $options.filters.slugify(object.title)) }}
                </span>
                <span v-else>
                  {{ object.title}}
                </span>
              </span>
            </td>
            <td>
              <span v-if="object.model" class="text-normal">
                <font-awesome-icon icon="desktop" size="lg" class="mr-1" v-if="object.model.who_am_i == 'App\\System\\Models\\System'"/>
                <font-awesome-icon icon="cubes" size="lg" class="mr-1" v-if="object.model.who_am_i == 'App\\Activity\\Models\\Activity'"/>
                <font-awesome-icon icon="cube" size="lg" class="mr-1" v-if="object.model.who_am_i == 'App\\Process\\Models\\Process'"/>
                <font-awesome-icon icon="file-signature" size="lg" class="mr-1" v-if="object.model.who_am_i == 'App\\Maintenance\\ThirdParty\\Models\\ThirdParty'"/>
                <font-awesome-icon icon="file-invoice" size="lg" class="mr-1" v-if="object.model.who_am_i == 'App\\Maintenance\\Policy\\Models\\Policy'"/>
                {{ object.model.name }}
              </span>
            </td>
            <td>
              <span class="mr-1" v-for="user in object.users">
                <span qid="profile-photo">
                  <Avatar :object="user" size="xs"></Avatar>
                </span>
              </span>
            </td>
            <td>
              <span v-if="object.status === 'completed'" >
                <font-awesome-icon icon="check-circle" class="icon-success"/>
              </span>
              <span v-if="object.status === 'pending'" class="pr-2">
                <font-awesome-icon
                    icon="exclamation-triangle"
                    class="risk-6"
                />
              </span>
              <span class="text-normal">
                {{ object.status | capitalize }}
              </span>
            </td>
            <td class="text-right">
              <b-button class="ml-2"
                        variant="light"
                        @click="showEditUsersModal(object)"
                        qid="delete-s-cancel-button"
                        v-if="object.status === 'pending'"
              >
                {{ $t('tasks.re_assign_button') }}
              </b-button>
              <AssessmentTaskModal
                  class=""
                  :task="object"
                  :tasks="selectedProject"
                  :fromHomepage="true"
                  @reloadContent="loadProjectTasks()"
                  v-if="(selectedProject.type == 'risk_assessment' || selectedProject.type == 'bia_assessment') && object.status === 'pending'"
              ></AssessmentTaskModal>
              <AssessmentGlobalSingleTaskModal
                  class=""
                  :task="object"
                  :tasks="selectedProject"
                  :fromHomepage="true"
                  @reloadContent="loadProjectTasks()"
                  v-if="selectedProject.type == 'control_assessment' && object.status === 'pending'"
              ></AssessmentGlobalSingleTaskModal>
              <RiskTaskModal
                  class=""
                  :task="object"
                  :tasks="selectedProject"
                  :fromHomepage="true"
                  @reloadContent="loadProjectTasks()"
                  v-if="(selectedProject.type == 'control' || selectedProject.type == 'security_measure') && object.status === 'pending'"
              ></RiskTaskModal>
              <UpdateTaskModal
                  class=""
                  :task="object"
                  :tasks="selectedProject"
                  :fromHomepage="true"
                  @reloadContent="loadProjectTasks()"
                  v-if="selectedProject.type == 'update' && object.status === 'pending'"
              ></UpdateTaskModal>
              <ValidationTaskModal
                  class=""
                  :task="object"
                  :tasks="selectedProject"
                  :fromHomepage="true"
                  @reloadContent="loadProjectTasks()"
                  v-if="selectedProject.type == 'validation' && object.status === 'pending'"
              ></ValidationTaskModal>

              <b-button class="mr-2"
                        variant="success"
                        @click="showViewTaskModal(object)"
                        qid="delete-s-cancel-button"
                        v-if="object.status === 'completed' && selectedProject.type != 'update' && selectedProject.type != 'validation'"
              >
                {{ $t('tasks.view_button') }}
              </b-button>
              <!-- <b-button
                  variant="delete"
                  @click="showConfirmDeleteModal(object)"
                  v-if="isGranted([permissions.PROJECT_EDIT, permissions.PROJECT_EDIT_OWN], object.project) && selectedProject.status != 'closed' && selectedProject.status != 'completed'"
                  qid="delete-s-cancel-button"
              >
                <font-awesome-icon icon="trash-alt"/>
              </b-button> -->
            </td>
          </tr>
          <tr v-if="open_tasks && !open_tasks.length && !loadingTasks" qid="no-results-row" class="text-center">
            <td colspan="10">
              <h5 class="mt-3">
                {{ $t('system.no_results') }}
              </h5>
            </td>
          </tr>
          <tr v-if="loadingTasks" qid="no-results-row-rr" class="text-center">
            <td colspan="10">
              <div class="mt-2 mb-4">
                <div class="swing-container">
                  <div class="swing">
                    <div class="swing-l"></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div class="swing-r"></div>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

        <div class="row">
          <div class="col-md-6">
            <div class="row">
              <div class="float-left">
                <span class="text-muted pagination-counter">
                  {{ $t('pagination.entries_per_page') }}:
                </span>
              </div>
              <div class="float-left">
                <multiselect
                    v-model="tasksPerPage"
                    :options="perPageOptions"
                    track-by="value"
                    label="value"
                    :select-label="$t('system.dropdown_select_label')"
                    :selected-label="$t('system.dropdown_selected_label')"
                    :deselect-label="$t('system.dropdown_deselect_label')"
                    qid="create-org-form-organization-level"
                    @select="tasksPerPageChanged"
                    :placeholder="tasksSelectedPerPage"
                    @remove="tasksPerPageRemoved"
                ></multiselect>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <b-pagination
                class="float-right"
                v-model="tasksCurrentPage"
                :total-rows="tasksRows"
                :per-page="tasksSelectedPerPage"
                aria-controls="my-table-1"
                @change="tasksPageChanged"
                limit="1"
            >
              <span class="text-muted" slot="first-text"><font-awesome-icon icon="angle-double-left"/></span>
              <span class="text-muted" slot="prev-text"><font-awesome-icon icon="angle-left"/></span>
              <span class="text-muted" slot="next-text"><font-awesome-icon icon="angle-right"/></span>
              <span class="text-muted" slot="last-text"><font-awesome-icon icon="angle-double-right"/></span>
              <div slot="ellipsis-text">
                <b-spinner small type="grow"></b-spinner>
                <b-spinner small type="grow"></b-spinner>
                <b-spinner small type="grow"></b-spinner>
              </div>
              <span class="text-muted" slot="page" slot-scope="{ page, active }">
                <span v-if="active">{{getTasksPerPage}}</span>
              </span>
            </b-pagination>
          </div>
        </div>

      <div class="text-right">
        <b-button class="mt-3"
                  variant="secondary"
                  @click="hideViewProjectModal"
                  qid="create-rr-cancel-button"
        >
          {{ $t('system.close') }}
        </b-button>
      </div>
    </b-modal>


    <!-- Re-assign modal -->
    <b-modal ref="re-assign" hide-footer @hide="hideEditUsersModal">
      <div class="d-block text-center">
        <h4 qid="update-tp-title">
          {{ $t('tasks.re_assign.title') }}
        </h4>
      </div>
      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="create-p-error"
      >
        {{ error }}
      </b-alert>
      <b-form @submit="reassignFormSubmit" qid="create-p-form" v-if="selectedTask && selectedTask.model">
        <div class="form-container">
          <b-form-group>
            <label qid="create-p-users-label">
              {{ $t('projects.create.owners_label') }}
            </label>
            <multiselect
                v-model="selectedAssignUsers"
                :options="allUsers"
                :multiple="true"
                :taggable="false"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                track-by="slug"
                :placeholder="$t('projects.create.owners_placeholder')"
                label="name"
                qid="create-p-users-select"
            >
              <template slot="tag" slot-scope="props">
                <span class="mr-3 user-tag">
                  <Avatar :object="props.option" size="xs"></Avatar>
                  <span class="ml-2">{{ props.option.name }}</span>
                </span>
              </template>
              <template slot="option" slot-scope="props">
                <Avatar :object="props.option" size="xs"></Avatar>
                <span class="ml-2">
                  {{ props.option.name }}
                </span>
              </template>
            </multiselect>
          </b-form-group>
        </div>
        <div class="text-right">
          <b-button class="mt-3"
                    variant="secondary"
                    @click="hideEditUsersModal"
                    qid="create-p-cancel-button"
          >
            {{ $t('projects.create.cancel') }}
          </b-button>
          <b-button type="submit"
                    class="mt-3 ml-3"
                    variant="success"
                    :disabled="buttonDisabled"
                    qid="create-p-submit-button"
          >
            <span v-if="buttonDisabled" class="mr-1">
              <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
            </span>
            {{ $t('projects.create.submit') }}
          </b-button>
        </div>
      </b-form>
    </b-modal>


    <TaskViewModal
        :selectedTask="selectedTask"
        :showModal="viewTaskModal"
        @closeViewModal="hideViewTaskModal"
    ></TaskViewModal>

  </div>

</template>

<script>
  import piincHttp from '@/util/configureAxios.js';
  import {config} from '@/config.js';
  import UpdateTaskModal from '@/views/Tasks/UpdateTaskModal.vue';
  import ValidationTaskModal from '@/views/Tasks/ValidationTaskModal.vue';
  import AssessmentTaskModal from '@/views/Tasks/AssessmentTaskModal.vue';
  import AssessmentGlobalTaskModal from '@/views/Tasks/AssessmentGlobalTaskModal.vue';
  import AssessmentGlobalSingleTaskModal from '@/views/Tasks/AssessmentGlobalSingleTaskModal.vue';
  import RiskTaskModal from '@/views/Tasks/RiskTaskModal.vue';
  import Avatar from '@/components/Avatar.vue';
  import TaskViewModal from '@/views/Tasks/TaskViewModal.vue';

  export default {
    name: 'TaskToolbar',
    data: function() {
      return {
        loadingOpen: true,
        myTasks: [],
        activeTask: 0,
        activeTaskObject: {},
        currentTaskPosition: '',
        showToolbarNavigation: false,
        showToolbar: false,
        taskListOpened: false,
        activeProject: {},
        myProjects: [],
        forceProjectUpdate: false,
        selectedTask: [],
        viewTaskModal: false,
        selectedProject: {},
        open_tasks: [],
        loadingTasks: false,
        selectedAssignUsers: [],
        error: '',
        allUsers: [],
        buttonDisabled: false,

        // Pagination
        perPageOptions: [
          { name: '10', value: '10' },
          { name: '20', value: '20' },
          { name: '50', value: '50' },
          { name: '100', value: '100' }
        ],

        // Tasks pagination
        tasksPerPage: '',
        tasksCurrentPage: 1,
        tasksSelectedPerPage: "10",
        tasksTotalRows: 0,
      }
    },
    props: {
      forceOpen: {
        type: Boolean
      },
    },
    components: {
      UpdateTaskModal,
      ValidationTaskModal,
      AssessmentTaskModal,
      AssessmentGlobalTaskModal,
      AssessmentGlobalSingleTaskModal,
      RiskTaskModal,
      Avatar,
      TaskViewModal
    },
    computed: {
      getClient() {
        return this.$store.state.client
      },
      getUser() {
        return this.$store.state.user
      },
      getUpdateTasks() {
        return this.$store.state.updateTasks
      },
      getActiveTaskObject() {
        return this.$store.state.activeTaskObject
      },
      getActiveTaskPosition() {
        return this.$store.state.activeTaskPosition
      },
      getTaskToolbarState() {
        return this.$store.state.taskToolbarState
      },
      getTasksPerPage() {
        let page = this.tasksCurrentPage;
        let selectedFrom = (page-1) * Number(this.tasksSelectedPerPage) + 1;
        let selectedTo = (page-1) * Number(this.tasksSelectedPerPage) + Number(this.tasksSelectedPerPage);
        let selectedOf = this.tasksTotalRows;

        if (selectedTo > selectedOf) {
          selectedTo = selectedOf
        }

        return selectedFrom + " - " + selectedTo + " " + this.$t('system.of') + " " + selectedOf
      },
      tasksRows() {
        // Use computed value for rows because of dynamic update
        return this.tasksTotalRows
      }
    },
    watch: {
      // Watch when client changes in store and trigger api reload
      getClient: function () {
      },
      getUpdateTasks: function (newValue, oldValue) {
        if (newValue) {

        }
      },
      getActiveTaskObject: function (newValue, oldValue) {
        let self = this;
        if (this.$route.name == 'activities.view' || this.$route.name == 'systems.view' || this.$route.name == 'processes.view' || this.$route.name == 'contracts.view' || this.$route.name == 'policies.view') {
          if (newValue && oldValue && newValue.id && oldValue.id && (newValue.model_type !== oldValue.model_type || newValue.model_id !== oldValue.model_id)) {
            this.navigateToTask(newValue)
          } else {

            if (this.getActiveTaskObject && this.getActiveTaskObject.id && this.$route.params && this.$route.params.slug && this.getActiveTaskObject.model && this.getActiveTaskObject.model.slug == this.$route.params.slug) {
              this.showToolbarNavigation = true;
              if (this.myTasks && this.myTasks.length) {
                _.forEach(self.myTasks, function (value, key) {
                  if (self.getActiveTaskObject.id == value.id) {
                    self.currentTaskPosition = key;
                    self.$store.commit('storeActiveTaskPosition', key);
                  }
                })
              }
              this.handleScroll(newValue, oldValue)
            } else {
              this.showToolbarNavigation = false;
            }
          }
        }
      }
    },
    methods: {
      closeToolbar() {
        this.$store.commit('storeTaskToolbarState', false);
      },
      isOwner(object) {
        let self = this;
        let existingUser = _.find(object.users, function(user) {
          return user.id == self.getUser.id
        });
        return existingUser
      },
      tasksPageChanged(page) {
        this.loadProjectTasks(page)
      },
      tasksPageChanged(page) {
        this.loadProjectTasks(page)
      },
      tasksPerPageChanged(perPage) {
        let self = this;
        self.tasksSelectedPerPage = perPage.value
        this.$store.commit('storePerPage', this.tasksSelectedPerPage);
        // Load content when page changed listener is triggered
        this.loadProjectTasks(1, perPage.value)
      },
      tasksPerPageRemoved() {
        let self = this;
        // Load content when page changed listener is triggered
        self.tasksSelectedPerPage = self.perPageOptions[0].value
        this.loadProjectTasks(1, self.tasksSelectedPerPage)
      },
      showViewTaskModal(object) {
        this.selectedTask = object
        this.viewTaskModal = true
      },
      hideViewTaskModal() {
        this.selectedTask = {}
        this.viewTaskModal = false
      },
      hideEditUsersModal() {
        this.selectedTask = {}
        this.selectedAssignUsers = []
        this.$refs['re-assign'].hide()
      },
      showEditUsersModal(object) {
        let self = this;
        this.error = '';
        let task = object

        let role_name = [self.permissions.ROLE_CLIENT_ADMIN];

        piincHttp.get('tasks/' + object.id).then(function(response) {
          task = response.data;
          if (task.project.type == 'control' || task.project.type == 'security_measure' || task.project.type == 'control_assessment') {
            role_name.push(self.permissions.ROLE_MEMBER);
            role_name.push(self.permissions.ROLE_VALIDATOR);
          }

          if (self.getClient && self.getClient.parent) {
            role_name.push(self.permissions.ROLE_PARTITION_ADMIN);
          }
        }, function() {});

        this.selectedAssignUsers = [];
        piincHttp.get('users', { params:
          {
            client: this.getClient.id,
            role_name: role_name,
            per_page: 100
          }
        }).then(function(response) {
          let users = response.data.items
          _.forEach(object.users, function (user) {
            if (_.findIndex(users, function(o) { return o.id == user.id; }) == -1) {
              if (user.id != self.getUser.id) {
                users.push(user)
              }
            }
            if (user.id != self.getUser.id) {
              let matchedUser = _.cloneDeep(user)
              if (user.id == object.owner) {
                matchedUser.owner = true
              }
              self.selectedAssignUsers.push(matchedUser)
            }
          })
          self.allUsers = _.uniq(users)
        }, function() {});

        this.selectedTask = object
        this.$refs['re-assign'].show()
      },
      reassignFormSubmit(evt) {
        this.buttonDisabled = true;
        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        let userIds = [];
        evt.preventDefault();

        if (this.selectedAssignUsers && this.selectedAssignUsers.length) {
          for (var i = 0; i < this.selectedAssignUsers.length; i++) {
            userIds.push(this.selectedAssignUsers[i].id);
          }
        }

        if (userIds && userIds.length) {
          piincHttp.put('tasks/' + this.selectedTask.id, {
            users: userIds,
            reasign: 'replace'
          }).then(function(response) {
            self.hideEditUsersModal();
            self.loadProjectTasks()
            self.$toastr('success', self.$t('tasks.re_assign.success'))
            self.buttonDisabled = false;
          }, function(error) {
            if (error.status !== 200) {
              self.buttonDisabled = false;
              self.error = error.data.message;
            }
          })
        } else {
          self.error = self.$t('tasks.re_assign.required')
          self.buttonDisabled = false;
        }
      },
      loadProjectTasks(page, perPage) {
        let self = this;
        this.loadingTasks = true;
        this.open_tasks = []

        if (this.getStorePerPage) {
          this.tasksSelectedPerPage = this.getStorePerPage;
        }

        // If page is not defined, set page to default 1
        let pageNumber = page ? page : 1;
        let perPageNumber = perPage ? perPage : this.tasksSelectedPerPage;

        piincHttp.get('projects/' + this.selectedProject.slug + '/tasks/me', { params:
          {
            page: pageNumber,
            per_page: perPageNumber,
          }
        }).then(function(response) {
          self.open_tasks = response.data.items;
          // Set number of total items
          self.tasksTotalRows = response.data.total_count;
          self.loadingTasks = false;
        }, function() {});
      },
      openViewProjectModal(object) {
        let self = this;
        this.selectedProject = object
        this.loadProjectTasks()
        this.$refs['view-project'].show()
      },
      hideViewProjectModal() {
        this.selectedProject = {}
        this.open_tasks = []
        this.$refs['view-project'].hide()
      },
      navigateToTask(object) {
        this.$store.commit('storeActiveTask', object);
        if (object.model_type == 'App\\Activity\\Models\\Activity') {
          this.$router.push({ name: 'activities.view', params: { slug: object.model.slug }, query: { task: object.id }})
        }
        if (object.model_type == 'App\\Process\\Models\\Process') {
          this.$router.push({ name: 'processes.view', params: { slug: object.model.slug }, query: { task: object.id }})
        }
        if (object.model_type == 'App\\System\\Models\\System') {
          this.$router.push({ name: 'systems.view', params: { slug: object.model.slug, }, query: { task: object.id }})
        }
        if (object.model_type == 'App\\Maintenance\\ThirdParty\\Models\\ThirdParty') {
          this.$router.push({ name: 'contracts.view', params: { slug: object.model.slug, }, query: { task: object.id }})
        }
        if (object.model_type == 'App\\Maintenance\\Policy\\Models\\Policy') {
          this.$router.push({ name: 'policies.view', params: { slug: object.model.slug, }, query: { task: object.id }})
        }
      },
      handleScroll(object, oldObject) {

        if (!object.code) {
          let oldClass = document.querySelector(".highlight");
          if (oldClass) {
            oldClass.classList.remove("highlight");
          }
        }

        if (object.code == 'update_systems' ||
            object.code == 'update_third_party_sources' ||
            object.code == 'update_third_party_receivers' ||
            object.code == 'update_mapping_description' ||
            object.code == 'validate_system' ||
            object.code == 'validate_third_party_data_source' ||
            object.code == 'validate_third_party_receiver' ||
            object.code == 'validate_mapping_description'
          ) {
          this.$emit('updateTab', 'data-mapping');
          this.$store.commit('storeTabIndex', 'data-mapping');
        }

        if (object.code == 'validate_third_party' ||
            object.code == 'validate_policy'
        ) {
          this.$emit('updateTab', 'validations');
          this.$store.commit('storeTabIndex', 'validations');
        }

        if (object.code == 'update_third_parties') {
          this.$emit('updateTab', 'relations-third-parties');
          this.$store.commit('storeTabIndex', 'relations-third-parties');
        }

        if (object.code == 'update_processing_role' ||
            object.code == 'update_data_subject' ||
            object.code == 'update_retention_rule' ||
            object.code == 'update_integrity_check' ||
            object.code == 'update_principles_of_proportionality' ||
            object.code == 'update_processing_type' ||
            (object.code == 'update_measures' && object.model_type == 'App\\Activity\\Models\\Activity') ||
            (object.code == 'validate_measures' && object.model_type == 'App\\Activity\\Models\\Activity') ||
            object.code == 'validate_retention_rule' ||
            object.code == 'validate_integrity_check' ||
            object.code == 'validate_principles_of_proportionality' ||
            object.code == 'validate_processing_type'
          ) {
          this.$emit('updateTab', 'gdpr');
          this.$store.commit('storeTabIndex', 'gdpr');
        }

        if (object.code == 'update_legal_basis' ||
            object.code == 'update_information_obligation' ||
            object.code == 'update_risk_profile' ||
            object.code == 'update_loss_of_confidentiality' ||
            object.code == 'update_loss_of_integrity' ||
            object.code == 'update_loss_of_availability' ||
            object.code == 'validate_legal_basis' ||
            object.code == 'validate_information_obligation' ||
            object.code == 'validate_risk_profile' ||
            object.code == 'validate_confidentiality_impact_and_probability' ||
            object.code == 'validate_integrity_impact_and_probability' ||
            object.code == 'validate_availability_impact_and_probability'
          ) {
          this.$emit('updateTab', 'eu-gdpr');
          this.$store.commit('storeTabIndex', 'eu-gdpr');
        }

        if (object.code == 'update_data_objects') {
          this.$emit('updateTab', 'data');
          this.$store.commit('storeTabIndex', 'data');
        }

        if (object.code == 'update_policies_and_procedures' ||
            object.code == 'update_organization' ||
            object.code == 'update_basic_info' ||
            object.code == 'update_documents' ||
            object.code == 'update_description'
          ) {
          this.$emit('updateTab', 'basic-info');
          this.$store.commit('storeTabIndex', 'basic-info');
        }

        if (object.code == 'update_risk_scenarios' || object.code == 'validate_risk_scenarios') {
          this.$emit('updateTab', 'risk-management');
          this.$store.commit('storeTabIndex', 'risk-management');
        }

        if (object.code == 'update_subdata_processors') {
          this.$emit('updateTab', 'subdata-processors');
          this.$store.commit('storeTabIndex', 'subdata-processors');
        }

        if (object.code == 'update_data_processor_agreement') {
          this.$emit('updateTab', 'data-processor-agreement');
          this.$store.commit('storeTabIndex', 'data-processor-agreement');
        }

        if ((object.code == 'update_measures' && object.model_type == 'App\\Maintenance\\ThirdParty\\Models\\ThirdParty') ||
          object.code == 'validate_measures'
        ) {
          this.$emit('updateTab', 'contract-measures');
          this.$store.commit('storeTabIndex', 'contract-measures');
        }

        if (object.code == 'update_access_control' ||
            object.code == 'update_log_management' ||
            object.code == 'update_network' ||
            object.code == 'update_data_discovery' ||
            (object.code == 'update_measures' && object.model_type == 'App\\System\\Models\\System') ||
            (object.code == 'validate_measures' && object.model_type == 'App\\System\\Models\\System') ||
            object.code == 'validate_access_control' ||
            object.code == 'validate_log_management' ||
            object.code == 'validate_network' ||
            object.code == 'validate_data_discovery'
          ) {
          this.$emit('updateTab', 'controls');
          this.$store.commit('storeTabIndex', 'controls');
        }

        setTimeout(function() {
          var element = document.getElementById(object.code);

          element.scrollIntoView(true);
          window.scrollBy(0, -100);

          if (object.code.startsWith("validate")) {
            element.classList.add("borderBlink");
            setTimeout(function() {
              element.classList.remove("borderBlink");
            }, 7000)
          } else {
            element.classList.add("highlight");
            setTimeout(function() {
              element.classList.add("highlight-fade-out");
            }, 4000)
          }

          if (oldObject && oldObject.id != object.id) {
            var oldElement = document.getElementById(oldObject.code);
            oldElement.classList.remove("highlight");
          }
        }, 2000)

      }

    },
    created () {
      let self = this;

      if (this.$route.name == 'activities.view' || this.$route.name == 'systems.view' || this.$route.name == 'processes.view' || this.$route.name == 'contracts.view' || this.$route.name == 'policies.view') {
        // do something
      } else {
        this.$store.commit('storeTabIndex', '');
      }

      // Handle task toolbar if param is provided
      if (this.$route.query.task || (this.getActiveTaskObject && this.getActiveTaskObject.id && this.$route.params && this.$route.params.slug && this.getActiveTaskObject.model && this.getActiveTaskObject.model.slug == this.$route.params.slug)) {
        this.showToolbarNavigation = true;
        this.activeTask = this.$route.query.task
        this.handleScroll(this.getActiveTaskObject)
      }

    }
  }
</script>
